import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserLogged } from '../features/common/commonSelectors';

export const PrivateRoute = ({ component: Component, ...rest }) => {

  const userLogged = useSelector(selectUserLogged);

  return (
    <Route
      {...rest}
      render={(props) => {

        const currentUser = userLogged?.id;

        if (!currentUser) {
          // not logged in so redirect to login page with the return url
          return (
            <Redirect
              to={{
                pathname: "/authentication/Login",
                state: { from: props.location },
              }}
            />
          );
        }

        // authorised so return component
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
